import {
  deleteFolder,
  downloadVideo,
  duplicateVideo,
  getVideos,
} from 'lib/api';
import {
  ArchiveButtonSwitch,
  CheckboxInput,
  LoadingIndicator,
  Search,
  TableContextProvider,
  TableFooter,
  TablePaginationNew,
  TablePaginationSizeNew,
} from 'lib/components';
import { HelpDesk } from 'lib/components/helpDesk';
import { EHelpDesk } from 'lib/components/helpDesk/utils';
import {
  ModalMoveCopy,
  ModalUpload,
  ModalVideoMergeListVideo,
  ModalWheelsTV,
} from 'lib/components/modal';
import { CEModalFolders } from 'lib/components/modal/foldersModals/CE_Modal';
import { ModalDeleteFolder } from 'lib/components/modal/foldersModals/Delete';
import { Container, Flex, MainWrapper } from 'lib/components/styles/layout';
import { successToast } from 'lib/components/toasts/success';
import { VideoEmailStatus, VideoStatus } from 'lib/const';
import {
  CDSVideoListFilter,
  VideoListAutomotiveItem,
  useAuth,
} from 'lib/context';
import { useToastError } from 'lib/hooks';
import { debounce, keyBy } from 'lodash';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { IoMdLock } from 'react-icons/io';
import { MdAdd, MdAddToPhotos } from 'react-icons/md';
import { useQuery, useQueryClient } from 'react-query';
import { useHistory, useLocation } from 'react-router';
import styled, { useTheme } from 'styled-components/macro';
import {
  ALL_FOLDERS_VALUE,
  DEFAULT_FOLDER,
  DEFAULT_FOLDER_WITH_USER_ID,
} from 'lib/const/Folders';
import { VideoItem, VideoItemCompany } from '../../components';
import { VideoItemType } from '../../components/VideoItem';
import { ModalFilterVideos, SelectedVideos } from '../components';
import {
  PackageNameLabel,
  checkIfFeatureIsEnabled,
  productFeature,
  VideoLimitStatus,
} from 'lib/utils/productFeature';
import { ShareFoldersEditModal } from 'lib/components/folders/ShareFoldersEditModal';
import { ResellerModal } from 'lib/components/folders/ResellerModal';
import { ShareFoldersModal } from 'lib/components/folders/ShareFoldersModal';
import ResellerEditModal from 'lib/components/folders/ResellerEditModal';
import {
  DEFAULT_COMPANY_FOLDER,
  SHARED_FOLDER_PREFIX,
} from 'lib/const/Folders';
import ProductInfoTooltip from 'lib/components/ProductInfoTooltip/ProductInfoTooltip';
import { checkIfFreemium } from 'lib/utils/functions';
import { ModalLeaveFolder } from 'lib/components/modal/ModalLeaveFolder';
import { FOLDER_ACCESS } from '../constants';
import selectors from '../../../../../../cypress/selectors';
import { Button, Typography } from 'react-covideo-common';
import { FaFilter } from 'react-icons/fa';
import { BiChevronDown } from 'react-icons/bi';
import { IoCarSport } from 'react-icons/io5';
import { ModalLesaVideos } from 'lib/components/modal/lesaModal/ModalLesaVideos';
import { useEditVideoRequestMutation } from 'lib/api/videoRequests/useEditVideoRequestMutation';
import { videoRequestKeys } from 'lib/api/videoRequests/videoRequestKeys';
import { useVideoLimit } from 'lib/context/videolimit/VideoLimitContext';
import { useOrganizationVideosQuery } from 'lib/api/organizationVideo/useOrganizationVideoQuery';
import { ModalOrganizationVideos } from 'lib/components/modal/organizationVideosModal/ModalOrganizationVideos';
import { useCDK } from 'lib/hooks/useCdk';
import { useTranslation } from 'react-i18next';

import { getArchiveView, VideoPages } from 'lib/const/VideoPages';
import {
  ParagraphNormal,
  ParagraphNormalBold15,
  ParagraphSmallBold,
} from 'lib/components/styles/typography';
import { Menu } from 'lib/components/folders/style';
import wheelsTV from 'assets/icons/WheelsTV.svg';
import lesa from 'assets/icons/Lesa.svg';
import VINReels from 'assets/icons/VINReelsLibrary.svg';
import { AddonDropdown } from 'lib/components/dropdown/AddonDropdown';
import { useOnClickOutside } from 'lib/utils';
import { Tooltip } from 'react-covideo-common';
import { FolderV2Dropdown } from 'lib/components/dropdown/folders/FolderV2Dropdown';
import {
  FOLDER_ACCESS_RIGHTS,
  FOLDER_TYPES,
  FoldersV2,
  useGetFoldersV2,
} from 'lib/api/folders/getFoldersV2';
import { FolderActions } from '../components/FolderActions';
import { mapFolderToOption } from 'lib/utils/folders';
import { FOLDER_SHARED_AS } from '../components/types';
import { AdminSelectionModal } from 'lib/components/modal/foldersModals/AdminSelectionModal';
import { StopFolderSharingModal } from 'lib/components/modal/foldersModals/StopFolderSharingModal';
import { useRemoveFolderAccessSettings } from 'lib/api/folderAccess/useRemoveFolderAccessSettings';
import { ModalVinReels } from 'lib/components/modal/vinReelsModal/ModalVinReels';
import { useAIFeatureAvailability } from 'lib/hooks/features/ai/useAIFeatureAvailability';
import { getSecondaryColor } from 'lib/context/theme/utils';
import { FolderOption } from 'lib/components/dropdown/folders/customOption';
import {
  getSelectedFolder,
  setLastSelectedFolderToLocalStorage,
} from 'lib/components/dropdown/helpers/helpers';

const CheckVideoListItemWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;
const CheckboxInputWrapper = styled.div`
  margin-right: 16px;
  margin-top: 38px;
`;
const CheckboxInputPlaceholder = styled.div`
  margin-right: 24px;
`;
const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-left: 40px;

  .countRecord {
    font-size: 12px;
    font-weight: bold;
    line-height: 1.82;
  }
  .textRed {
    color: red;
  }
  .textAmber {
    color: #ff8b21;
  }
`;

const Filter = styled.div<{ minWidth?: string }>`
  margin-right: 8px;
  min-width: ${props => props.minWidth || '180px'};
`;
const NoList = styled.div`
  padding-left: 40px;
`;

const PaginationWrapper = styled.div`
  padding-left: 40px;
`;

const SharedInfoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-left: 40px;
  gap: 8px;
`;
const SharedTitle = styled.div`
  color: ${({ theme }) => theme.colors.neutral[80]};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 171.429% */
`;

type FolderWrapperProps = {
  marginRight: string;
};
const FoldersWrapper = styled.div<FolderWrapperProps>`
  display: flex;
  gap: 6px;
  margin-right: ${props => props.marginRight};
  border-radius: 6px;
  .delete,
  .edit {
    cursor: pointer;
    width: 24px;
    height: 24px;
    padding: 8px;
  }
  .edit:hover {
    background: ${({ theme }) => theme.colors.neutral[20]};
    color: ${({ theme }) => theme.colors.black[100]} !important;
  }
  .delete:hover {
    background: ${({ theme }) => theme.colors.danger.non_alpha};
    color: ${({ theme }) => theme.colors.danger[100]} !important;
  }
  div[id$='option-0'] {
    color: ${({ theme }) => getSecondaryColor(theme)};
    margin-top: -4px;
    height: 44px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[40]};
  }
`;

const DisabledMergeContainer = styled.div`
  margin: 0 0 0 auto;
  button {
    cursor: not-allowed;
  }
`;

const ActionWrapper = styled.div`
  margin-left: auto;
  display: flex;
  gap: 8px;
`;

const DropdownTrigger = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: ${({ theme }) => theme.colors.secondary.non_alpha};
  border: 1px solid ${({ theme }) => theme.colors.neutral[20]};
  border-radius: 5px;
  cursor: pointer;
  border-radius: 5px;
  border-width: 1px;
  padding: 7px;
  gap: 12px;

  :hover {
    border: 1px solid ${({ theme }) => getSecondaryColor(theme, 40)};
  }
`;

const DEFAULT_PAGE = 0;
const DEFAULT_SIZE = 10;
const MAX_PINNED_VIDEOS_COUNT = 5;

const PRIMARY_FOLDER_ID = -2;

export const List = () => {
  const queryClient = useQueryClient();
  const location = useLocation();
  const queryParams: any = queryString.parse(location.search);
  const [showEditFolderModal, setShowEditFolderModal] = useState(false);
  const [showDeleteFolderModal, setShowDeleteFolderModal] = useState(false);
  const history = useHistory();
  const { showError } = useToastError();
  const { userData } = useAuth();
  const { secondaryToText } = useCDK();
  const { t } = useTranslation();
  const {
    isAutomotive,
    isAutomotiveServiceRole,
    trialExpired,
    customer: { customerOrganizations },
  } = userData;
  const themes = useTheme();
  const archiveViewOptions = getArchiveView(t);
  const [selectedVideosData, setSelectedVideosData] = useState<any[]>([]);
  const [showModalFilterVideos, setShowModalFilterVideos] = useState(false);
  const [showWTVModal, setWTVModal] = useState(false);
  const [showLesaModal, setShowLesaModal] = useState(false);
  const [showVinReelsModal, setShowVinReelsModal] = useState(false);
  const [showOrganizationVideosModal, setShowOrganizationVideosModal] =
    useState(false);
  const [showMergeModal, setShowMergeModal] = useState(false);
  const [videoMergeEnabled, setVideoMergeEnabled] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [showActionDropdown, setShowActionDropdown] = useState(false);
  const [containsSharedFolderVideo, setContainsSharedFolderVideo] =
    useState(false);
  const [defaultArchiveValue, setDefaultArchiveValue] = React.useState(
    archiveViewOptions[1].value
  );
  const [showModalMoveCopyForVideos, setShowModalMoveCopyForVideos] = useState<{
    videoIds: string[];
    folder?: FoldersV2;
  }>({
    videoIds: [],
    folder: undefined,
  });
  const [selectedVideo, setSelectedVideo] =
    useState<VideoListAutomotiveItem | null>(null);

  const [showLeaveFolderModal, setShowLeaveFolderModal] = useState(false);
  const [showStopFolderSharingModal, setShowStopFolderSharingModal] =
    useState(false);
  const [pinnedVideos, setPinnedVideos] = useState<VideoListAutomotiveItem[]>(
    []
  );
  const { videoLimitStatus, setVideoLimitStatus } = useVideoLimit();
  const [disablePinButton, setDisablePinButton] = useState(false);
  const [currentFolder, setCurrentFolder] = useState<FoldersV2>(
    DEFAULT_FOLDER_WITH_USER_ID(userData.id)
  );
  const { isVinReelsFeatureAvailable } = useAIFeatureAvailability();

  // all filters are fetched from the URL
  let filter: CDSVideoListFilter = {
    videoType: queryParams.videoType || '',
    userId: queryParams.userId || '',
    advisorId: queryParams.advisorId || '',
    status: queryParams.status || VideoStatus.NoStatus,
    emailStatus: queryParams.emailStatus || VideoEmailStatus.NoStatus,
    folderId: queryParams.folderId || DEFAULT_FOLDER.folderId,
    page: queryParams.page
      ? Math.abs(parseInt(queryParams.page?.toString(), 10))
      : DEFAULT_PAGE,
    size: queryParams.size
      ? Math.abs(parseInt(queryParams.size?.toString(), 10))
      : DEFAULT_SIZE,
    searchQuery: queryParams.searchQuery || '',
    isArchived: Number(queryParams.isArchived) || Number(defaultArchiveValue),
  };

  //  status filtering disabled for company folder, reset status when folder set to company
  if (filter.folderId && filter.folderId.toString() === '-1') {
    filter.status = '';
    filter.emailStatus = '';
  }

  // count some filters to show on Filter Videos button
  const filterCount =
    (!!filter.videoType ? 1 : 0) +
    (!!filter.userId ? 1 : 0) +
    (!!filter.advisorId ? 1 : 0) +
    (!!filter.status ? 1 : 0) +
    (!!filter.emailStatus ? 1 : 0);

  const { data: orgVideoData, isLoading: isLoadingOrgVideo } =
    useOrganizationVideosQuery(
      {
        page: 0,
        limit: 1,
      },
      !!customerOrganizations && customerOrganizations.length > 0
    );

  const showOrgVideosButton = !isLoadingOrgVideo && !!orgVideoData?.count;
  const isWheelsTVEnabled =
    !isAutomotiveServiceRole && !!Number(userData.customer.wheelsTV);
  const isLesaEnabled = !!Number(userData.customer.lesaAccess);

  const enabledFeatures: string[] = [
    isWheelsTVEnabled ? t('Wheels TV') : '',
    isLesaEnabled ? t('Lesa') : '',
    showOrgVideosButton ? t('OEM Library') : '',
    isVinReelsFeatureAvailable ? t('VIN Reels') : '',
  ].filter(Boolean);

  const enabledCount = enabledFeatures.length;
  const isDropdownEnabled = enabledCount >= 2;

  const formatList = (items: string[]): string => {
    const last = items.pop();
    return `${items.join(', ')} & ${last}`;
  };

  const tooltipText = formatList([...enabledFeatures]);

  const dropdownItems = [
    {
      label: <ParagraphNormalBold15>{t('Wheels TV')}</ParagraphNormalBold15>,
      icon: <img src={wheelsTV} alt={t('Wheels TV')} width={24} height={24} />,
      onClick: () => {
        setShowActionDropdown(false);
        setWTVModal(true);
      },
      disabled: trialExpired,
      showItem: isWheelsTVEnabled,
      productFeatureId: productFeature.WTV,
      nextPlan: PackageNameLabel.ENTERPRISE,
    },
    {
      label: <ParagraphNormalBold15>{t('Lesa')}</ParagraphNormalBold15>,
      icon: <img src={lesa} alt={t('Lesa')} width={24} height={24} />,
      onClick: () => {
        setShowActionDropdown(false);
        setShowLesaModal(true);
      },
      disabled: trialExpired,
      showItem: isLesaEnabled,
    },
    {
      label: <ParagraphNormalBold15>{t('VIN Reels')}</ParagraphNormalBold15>,
      icon: <img src={VINReels} alt={t('VIN Reels')} width={24} height={24} />,
      onClick: () => {
        setShowActionDropdown(false);
        setShowVinReelsModal(true);
      },
      disabled: false,
      showItem: isVinReelsFeatureAvailable,
    },
    {
      label: <ParagraphNormalBold15>{t('OEM Library')}</ParagraphNormalBold15>,
      icon: (
        <img src={VINReels} alt={t('OEM Library')} width={24} height={24} />
      ),
      onClick: () => {
        setShowActionDropdown(false);
        setShowOrganizationVideosModal(true);
      },
      disabled: trialExpired,
      showItem: showOrgVideosButton,
    },
  ];

  const closeDropdown = () => {
    setShowActionDropdown(false);
  };
  const { ref } = useOnClickOutside(closeDropdown);

  const {
    data,
    refetch: refreshVideoList,
    isLoading: showLoading,
  } = useQuery(
    ['cds-videos', filter, currentFolder],
    async () =>
      await getVideos({
        folder: getFolderParam(),
        size: filter.size,
        page: filter.page,
        search: filter.searchQuery,
        isArchived: filter.isArchived,
        filter,
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      onSuccess: () => setSelectedVideosData([]),
    }
  );

  const { mutateAsync: editVideoRequestMutation } =
    useEditVideoRequestMutation();

  const emptyArray = React.useMemo(() => [], []);
  const { count: videoCount, videos } = data || {
    count: 0,
    videos: emptyArray,
  };
  const videoArray: VideoListAutomotiveItem[] =
    videos as unknown as VideoListAutomotiveItem[];

  const videoDictionary = keyBy(videoArray, 'id');
  const videoRequests = videoArray?.map(video => video.videoRequest);
  const videoRequestDictionary = keyBy(videoRequests, 'videoRequestId');

  /* SUS-1282 changes */
  const [disableDownloadButton, setDisableDownloadButton] =
    React.useState(false);
  const [totalSelectedDownloads, setTotalSelectedDownloads] = React.useState(0);
  const [downloadingCounter, setDownloadingCounter] = React.useState(0);
  const [showAdminSelectionModal, setShowAdminSelectionModal] =
    React.useState(false);
  const [showShareFoldersUsers, setShowShareFoldersUsers] =
    React.useState<boolean>(false);
  const [showShareFoldersResellers, setShowShareFoldersResellers] =
    React.useState<boolean>(false);
  const [showEditShareFolderModal, setShowEditShareFolderModal] =
    React.useState<boolean>(false);
  const [showEditResellerModal, setShowEditResellerModal] =
    React.useState(false);
  const [countColor, setCountColor] = useState('');
  const [videoCounter, setVideoCounter] = useState('');
  const [folders, setFolders] = useState<FoldersV2[]>([]);

  const isFolderShared = currentFolder.userId?.toString() !== userData.id;
  const isPersonalFolder =
    currentFolder.folderType === FOLDER_TYPES.PERSONAL ||
    currentFolder.userId?.toString() === userData.id;
  const hasUserCopyAccess = currentFolder.access === 'copy';
  const hasUserViewAccess = currentFolder.access === 'view';
  const hasUserEditAccess = currentFolder.access === 'edit';
  const selectedUsers: string[] | undefined = []; // for folder access

  const { mutateAsync: updateFolderAccessSettings } =
    useRemoveFolderAccessSettings();

  const { refetch: refetchFolders } = useGetFoldersV2({
    params: { getShared: true },
  });

  const openOemFolderShareModal = () => {
    const url = `/home/${VideoPages.FOLDER_SHARE_OEM}/${currentFolder.folderId}/${filter.page}`;
    history.push(url);
  };

  const openFolderShareModal = () => {
    const url = `/home/${VideoPages.FOLDER_SHARE}/${currentFolder.folderId}/${filter.page}`;
    history.push(url);
  };

  const handleOpenModal = () => {
    const isOrgAdmin = userData.isOrganizationAdmin;
    const isResellerAdmin = userData.isResellerAdmin;
    const folderSharedAs = currentFolder?.folderSharedAs;

    const openModalByRole = () => {
      if (folderSharedAs === FOLDER_SHARED_AS.COMPANY_ADMIN) {
        openFolderShareModal();
      } else if (folderSharedAs === FOLDER_SHARED_AS.OEM_ADMIN) {
        openOemFolderShareModal();
      } else {
        setShowAdminSelectionModal(true);
      }
    };

    if (isOrgAdmin && isResellerAdmin) {
      openModalByRole();
      return;
    }

    if (isOrgAdmin) {
      openOemFolderShareModal();
      return;
    }
    openFolderShareModal();
  };

  const handleStopSharingClick = () => {
    setShowStopFolderSharingModal(true);
  };

  const handleStopFolderSharing = async () => {
    setShowStopFolderSharingModal(false);
    await updateFolderAccessSettings({
      folderId: Number(currentFolder?.folderId) || 0,
    });
  };

  useEffect(() => {
    setDefaultArchiveValue(archiveViewOptions[1].value);
  }, [queryParams.folderId]);

  useEffect(() => {
    if (userData.access.toString() === '4') {
      history.push('/reports/users');
    }
  }, [userData]);

  useEffect(() => {
    if (!totalSelectedDownloads) {
      return;
    }
    setDisableDownloadButton(totalSelectedDownloads !== downloadingCounter);
  }, [totalSelectedDownloads, downloadingCounter]);

  useEffect(() => {
    setVideoMergeEnabled(
      checkIfFeatureIsEnabled(userData, productFeature.VIDEO_MERGE)
    );
  }, [userData]);

  useEffect(() => {
    if (showLoading) {
      return;
    }
    setPinnedVideos(videoArray.filter(video => !!video.pinnedVideo?.pinnedAt));
  }, [videoArray, showLoading]);

  useEffect(() => {
    if (showLoading) {
      return;
    }
    const selectedPinnedVideos = selectedVideosData.filter(video => {
      return !!video.pinnedAt;
    });

    const selectedUnpinnedVideosCount =
      selectedVideosData.length - selectedPinnedVideos.length;
    const currentCountForPin =
      pinnedVideos.length + selectedUnpinnedVideosCount;
    setDisablePinButton(currentCountForPin > MAX_PINNED_VIDEOS_COUNT);
  }, [pinnedVideos, selectedVideosData, showLoading]);

  useEffect(() => {
    if (!!selectedVideosData?.length && !!folders?.length) {
      for (const selectedVideo of selectedVideosData) {
        const video = videoDictionary[selectedVideo.id];
        if (video) {
          const shared = folders.find(
            folder =>
              folder.name === video.folder &&
              video.userId === folder.userId &&
              folder.folderType !== FOLDER_TYPES.PERSONAL
          );
          if (!!shared) {
            setContainsSharedFolderVideo(true);
            return;
          }
        }
      }
      setContainsSharedFolderVideo(false);
    }

    if (!!folders?.length) {
      const selectedFolder = getSelectedFolder(
        queryParams.folderId,
        folders,
        userData.id,
        t
      );

      // Update only if the folder actually changed
      const hasChanged =
        currentFolder.folderId?.toString() !== selectedFolder.folderId ||
        currentFolder.name !== selectedFolder.name;

      if (hasChanged) {
        setCurrentFolder(selectedFolder);
      }
    }
  }, [folders, selectedVideosData, queryParams.folderId]);

  /******/
  const getFolderParam = () => {
    const isAllFolders = currentFolder?.folderId === ALL_FOLDERS_VALUE;
    const currentFolderId = !isAllFolders
      ? parseInt(currentFolder?.folderId.toString(), 10)
      : 0;
    return currentFolderId > 0 && isFolderShared
      ? `${SHARED_FOLDER_PREFIX}${currentFolder.folderId}`
      : isAllFolders
        ? ALL_FOLDERS_VALUE
        : currentFolder.name;
  };

  const addFolderIDToUrl = (folderId: string | number) => {
    // reset to first page if folder set in case filtered results don't have multiple pages
    queryParams.page = DEFAULT_PAGE;
    queryParams.folderId = folderId;
    history.push({
      pathname: location.pathname,
      search: queryString.stringify(queryParams),
    });
  };

  const onSearch = (query: string) => {
    // reset to first page if search set in case filtered results don't have multiple pages
    queryParams.page = DEFAULT_PAGE;
    queryParams.searchQuery = query;
    history.push({
      pathname: location.pathname,
      search: queryString.stringify(queryParams),
    });
  };

  const handleReassignSubmit = async (
    advisorId: string,
    videos: any[],
    advisor: any
  ) => {
    const advisorName =
      advisor.firstName && advisor.lastName
        ? `${advisor.firstName} ${advisor.lastName}`
        : t('New Advisor');
    const videoRequestIds = videos.map((video: any) => {
      return videoDictionary[video.id].videoRequest.videoRequestId;
    });
    await Promise.all(
      videoRequestIds.map(async (videoRequestId: string | number) => {
        await editVideoRequestMutation({
          data: {
            advisorId: advisorId,
            status:
              videoRequestDictionary[videoRequestId].emailStatus ===
              VideoEmailStatus.NotSent
                ? VideoStatus.Pending
                : videoRequestDictionary[videoRequestId].status,
          },
          videoRequestId,
        });
      })
    );
    refreshVideoList();
    queryClient.refetchQueries(videoRequestKeys.count_pending());
    successToast({
      title: t('{{advisorName}} is now assigned to {{videoText}}!', {
        advisorName,
        videoText: videos.length > 1 ? t('these videos') : t('this video'),
      }),
    });
  };

  const handleDuplicate = async (video: any) => {
    try {
      await duplicateVideo({
        videosToDuplicate: [video.id],
      });
      successToast({
        title: t('Duplicated: {{title}}', { title: video.title }),
      });
    } catch (error) {
      showError(error);
    }

    refreshVideoList();
  };

  const handleMerge = (videoIds: string) => {
    const url = `/classic/merge?videos=${videoIds}`;
    history.push(url);
  };

  const handleDownload = async (
    downloadData: { videoId: string; title: string }[]
  ) => {
    /** SUS-1282 Changes **/
    if (disableDownloadButton) {
      successToast({
        title: t('Downloading is in progress...'),
      });
      return;
    }
    setDownloadingCounter(0);
    setTotalSelectedDownloads(downloadData.length);
    /*****/
    downloadData.map((d: any, index: number) =>
      setTimeout(async () => {
        /** SUS-1282 Changes **/
        if (index === 0) {
          successToast({
            title: t('Download Started...'),
          });
        }
        /*****/
        await downloadVideo(d.videoId, d.title);
        /** SUS-1282 Changes **/
        setDownloadingCounter(previous => {
          return previous + 1;
        });
        /*****/
      }, index * 500)
    );
  };

  const handleMoveCopyButtonClick = async (
    videoIds: string[],
    folder?: FoldersV2
  ) => {
    setShowModalMoveCopyForVideos({ videoIds, folder });
  };

  const handleMoveCopyDone = () => {
    setShowModalMoveCopyForVideos({
      videoIds: [],
      folder: undefined,
    });
    refreshVideoList();
  };

  // short debounce so you have time to add 2 digit page number
  const onPaginationChange = debounce(
    async ({
      page: newPage,
      size: newSize,
    }: {
      page: number;
      size: number;
    }) => {
      queryParams.page = Math.abs(newPage);
      queryParams.size = Math.abs(newSize);
      history.push({
        pathname: location.pathname,
        search: queryString.stringify(queryParams),
      });
    },
    300
  );
  const openEditFolderModal = () => {
    setShowEditFolderModal(true);
  };
  const closeEditFolderModal = () => {
    setShowEditFolderModal(false);
  };
  const openDeleteFolderModal = () => {
    setShowDeleteFolderModal(true);
  };
  const closeDeleteFolderModal = () => {
    setShowDeleteFolderModal(false);
  };

  const handleFolderDelete = async (data: any) => {
    try {
      await deleteFolder(currentFolder.folderId as number, data);
      refetchFolders();
      closeDeleteFolderModal();
      successToast({ title: t('Folder deleted successfully.') });
      setLastSelectedFolderToLocalStorage({
        folderId: PRIMARY_FOLDER_ID,
        userId: userData.userId,
      });
      addFolderIDToUrl(PRIMARY_FOLDER_ID);
    } catch (error) {
      showError(
        error,
        t('An error occured deleting your folder, please try again later.')
      );
    }
  };

  const isWTVEnabled = checkIfFeatureIsEnabled(userData, productFeature.WTV);
  const isFolderOrganizationEnabled = checkIfFeatureIsEnabled(
    userData,
    productFeature.FOLDER_ORGANIZATION
  );

  useEffect(() => {
    const userPackageDetails = userData?.user?.packageDetails;
    setVideoCounter(
      t('{{current}} / {{max}} Videos', {
        current: videoCount,
        max: userPackageDetails.maxVideosCreated,
      })
    );
    if (userPackageDetails.maxVideosCreated) {
      const usedLimitQuotaPercentage =
        (videoCount / parseInt(`${userPackageDetails.maxVideosCreated}`)) * 100;

      if (usedLimitQuotaPercentage > 80 && usedLimitQuotaPercentage < 100) {
        setCountColor('textAmber');
      } else if (usedLimitQuotaPercentage >= 100) {
        setCountColor('textRed');
      }

      let videoLimitStatus = VideoLimitStatus.NOT_REACHED;
      if (videoCount < userPackageDetails.maxVideosCreated) {
        videoLimitStatus = VideoLimitStatus.NOT_REACHED;
      } else if (videoCount === userPackageDetails.maxVideosCreated) {
        videoLimitStatus = VideoLimitStatus.REACHED;
      } else {
        videoLimitStatus = VideoLimitStatus.EXCEEDED;
      }

      setVideoLimitStatus(videoLimitStatus);
    }
  }, [videoCount, userData]);

  const showVideoCount = checkIfFreemium(userData);

  const handleOnMarkAsSentSuccessCallback = async () => {
    await refreshVideoList();
  };

  const isOwner =
    currentFolder && String(currentFolder?.userId) === userData.userId;
  const showUploadButton = () => {
    const isEditAccess =
      currentFolder &&
      Number(currentFolder.folderId) > 0 &&
      currentFolder.folderType === FOLDER_TYPES.SHARED &&
      currentFolder?.access === FOLDER_ACCESS_RIGHTS.EDIT;

    if (currentFolder.folderType === FOLDER_TYPES.DEFAULT) {
      return isEditAccess;
    }
    return isEditAccess || isOwner;
  };

  const showFolderOwnerAndSharedBy =
    currentFolder?.folderType !== FOLDER_TYPES.PERSONAL;
  let folderOwner = '';
  if (showFolderOwnerAndSharedBy) {
    if (currentFolder.folderType === FOLDER_TYPES.DEFAULT) {
      folderOwner = t('System');
    } else if (isOwner) {
      folderOwner = `${userData.firstName} ${userData.lastName || ''}`.trim();
    } else {
      folderOwner = currentFolder?.sharedBy || '';
    }
  }

  const onFolderChange = (option: FolderOption) => {
    const folderId = option?.value ?? DEFAULT_FOLDER.folderId;
    addFolderIDToUrl(folderId);
    setLastSelectedFolderToLocalStorage({ folderId, userId: userData.userId });
  };

  return (
    <div data-cy={selectors.libraryPage.videoListTable}>
      {showShareFoldersUsers && currentFolder && (
        <ShareFoldersModal
          handleModalClose={() => {
            setShowShareFoldersUsers(false);
          }}
          initUsers={selectedUsers}
          folderId={currentFolder.folderId.toString()}
          folder={currentFolder}
        />
      )}
      {showShareFoldersResellers && currentFolder && (
        <ResellerModal
          handleModalClose={() => {
            setShowShareFoldersResellers(false);
          }}
          initUsers={selectedUsers}
          folderId={currentFolder.folderId.toString()}
        />
      )}
      {showEditShareFolderModal && currentFolder && (
        <ShareFoldersEditModal
          handleModalClose={() => {
            setShowEditShareFolderModal(false);
          }}
          initUsers={selectedUsers}
          accessUsers={[]}
          folderId={currentFolder.folderId.toString()}
          isResellerAdmin={userData.isResellerAdmin}
          folder={currentFolder}
        />
      )}
      {showEditResellerModal && currentFolder && (
        <ResellerEditModal
          handleModalClose={() => {
            setShowEditResellerModal(false);
          }}
          folderId={currentFolder.folderId.toString() || ''}
          folder={currentFolder}
        />
      )}
      {!showLoading && !!selectedVideosData.length && !hasUserViewAccess && (
        <SelectedVideos
          videoArray={videoArray}
          selectedVideos={selectedVideosData}
          setSelectedVideos={setSelectedVideosData}
          handleReassignSubmit={handleReassignSubmit}
          handleMerge={handleMerge}
          handleDownload={handleDownload}
          handleMoveCopyButtonClick={handleMoveCopyButtonClick}
          disableDownloadButton={disableDownloadButton} /* SUS-1282 changes */
          refreshVideoList={refreshVideoList}
          folderAccess={currentFolder?.access ?? ''}
          isFolderShared={isFolderShared}
          videoLimitStatus={videoLimitStatus}
          disablePinButton={disablePinButton}
          currentFolder={currentFolder}
        />
      )}
      <>
        <Container>
          <MainWrapper resetPadding>
            <HelpDesk name={EHelpDesk.VIDEOS} />
            <FiltersContainer>
              <Filter>
                <Search
                  placeholder={t('Search videos...')}
                  onSearch={onSearch}
                  prevSearch={filter.searchQuery}
                />
              </Filter>
              {isFolderOrganizationEnabled ? (
                <FoldersWrapper marginRight={'8px'}>
                  <FolderV2Dropdown
                    onChange={onFolderChange}
                    value={{
                      value: currentFolder?.folderId,
                      label: currentFolder?.name,
                    }}
                    setFolders={setFolders}
                    maxMenuHeight={400}
                  />
                  <FolderActions
                    currentFolder={currentFolder}
                    handleOpenModal={handleOpenModal}
                    openDeleteFolderModal={openDeleteFolderModal}
                    openEditFolderModal={openEditFolderModal}
                    handleStopSharingClick={handleStopSharingClick}
                  />
                </FoldersWrapper>
              ) : (
                <></>
              )}

              {isAutomotive && (
                <Filter minWidth='40px'>
                  <Button
                    style={{
                      width: filterCount ? 'auto' : '40px',
                    }}
                    variant={secondaryToText}
                    disabled={trialExpired}
                    text={
                      filterCount ? t('filter', { count: filterCount }) : ''
                    }
                    onClick={() => setShowModalFilterVideos(true)}
                    icon={<FaFilter size={18} />}
                  />
                </Filter>
              )}

              {showVideoCount && (
                <div className={`countRecord ${countColor}`}>
                  {videoCounter}
                </div>
              )}

              <Menu>
                <ParagraphSmallBold>{t('Show Archived')}</ParagraphSmallBold>
                <ArchiveButtonSwitch
                  key={defaultArchiveValue}
                  defaultValue={defaultArchiveValue}
                  values={archiveViewOptions}
                  onChange={newView => {
                    setDefaultArchiveValue(newView);
                    queryParams.isArchived = newView;
                    refreshVideoList();
                  }}
                />
              </Menu>
              <ActionWrapper>
                {isPersonalFolder || hasUserEditAccess ? (
                  videoMergeEnabled ? (
                    <Button
                      variant='secondary'
                      icon={<MdAddToPhotos size={24} />}
                      onClick={() => setShowMergeModal(true)}
                      disabled={trialExpired}
                    />
                  ) : (
                    <DisabledMergeContainer>
                      <ProductInfoTooltip
                        width={'fit-content'}
                        style={{
                          left: '-70px',
                          top: '-50px',
                        }}
                        productFeatureId={productFeature.VIDEO_MERGE}
                        nextPlan={PackageNameLabel.TEAMS}
                      >
                        <Button
                          icon={<IoMdLock width={24} height={24} />}
                          variant='secondary'
                          onClick={() => {}}
                          disabled={true}
                        />
                      </ProductInfoTooltip>
                    </DisabledMergeContainer>
                  )
                ) : (
                  <></>
                )}

                {isDropdownEnabled && (
                  <div
                    ref={ref}
                    style={{ position: 'relative', display: 'inline-block' }}
                  >
                    <Tooltip
                      extendStyles={{
                        element: {
                          width: '100%',
                          maxWidth: '200px',
                        },
                        popup: {
                          padding: '10px',
                          maxWidth: '200px',
                          whiteSpace: 'normal',
                          wordWrap: 'break-word',
                          overflow: 'hidden',
                        },
                      }}
                      popup={
                        <Typography variant='small'>{tooltipText}</Typography>
                      }
                    >
                      <DropdownTrigger
                        onClick={() => setShowActionDropdown(prev => !prev)}
                      >
                        <IoCarSport
                          size={24}
                          color={getSecondaryColor(themes)}
                        />
                        <BiChevronDown
                          size={20}
                          color={getSecondaryColor(themes, 40)}
                        />
                      </DropdownTrigger>
                    </Tooltip>
                    {!!showActionDropdown && (
                      <AddonDropdown dropdownItems={dropdownItems} />
                    )}
                  </div>
                )}
                {!isDropdownEnabled && showOrgVideosButton && (
                  <Tooltip
                    extendStyles={{
                      element: {
                        width: '100%',
                        maxWidth: '200px',
                      },
                      popup: {
                        padding: '10px',
                      },
                    }}
                    popup={
                      <Typography variant='small'>
                        {t('OEM Library')}
                      </Typography>
                    }
                  >
                    <Button
                      variant='secondary'
                      text=''
                      icon={<IoCarSport size={24} />}
                      onClick={() => setShowOrganizationVideosModal(true)}
                    />
                  </Tooltip>
                )}
                {!isDropdownEnabled &&
                  isWheelsTVEnabled &&
                  (isWTVEnabled ? (
                    <Tooltip
                      extendStyles={{
                        element: {
                          width: '100%',
                          maxWidth: '200px',
                        },
                        popup: {
                          padding: '10px',
                        },
                      }}
                      popup={
                        <Typography variant='small'>
                          {t('Wheels TV')}
                        </Typography>
                      }
                    >
                      <Button
                        variant='secondary'
                        icon={<IoCarSport size={24} />}
                        onClick={() => setWTVModal(true)}
                        disabled={trialExpired}
                        data-cy={selectors.libraryPage.wheelsTvButton}
                      />
                    </Tooltip>
                  ) : (
                    <ProductInfoTooltip
                      width={'fit-content'}
                      style={{
                        left: '-70px',
                        top: '-50px',
                      }}
                      productFeatureId={productFeature.WTV}
                      nextPlan={PackageNameLabel.ENTERPRISE}
                    >
                      <Button
                        icon={<IoMdLock width={24} height={24} />}
                        variant='secondary'
                        onClick={() => {}}
                        disabled={true}
                      />
                    </ProductInfoTooltip>
                  ))}

                {!isDropdownEnabled && isLesaEnabled && (
                  <Tooltip
                    extendStyles={{
                      element: {
                        width: '100%',
                        maxWidth: '200px',
                      },
                      popup: {
                        padding: '10px',
                      },
                    }}
                    popup={<Typography variant='small'>{t('Lesa')}</Typography>}
                  >
                    <Button
                      variant='secondary'
                      text=''
                      icon={<IoCarSport size={24} />}
                      onClick={() => setShowLesaModal(true)}
                      disabled={trialExpired}
                    />
                  </Tooltip>
                )}

                {!isDropdownEnabled && isVinReelsFeatureAvailable && (
                  <Tooltip
                    extendStyles={{
                      element: {
                        width: '100%',
                        maxWidth: '200px',
                      },
                      popup: {
                        padding: '10px',
                      },
                    }}
                    popup={
                      <Typography variant='small'>{t('VIN Reels')}</Typography>
                    }
                  >
                    <Button
                      variant='secondary'
                      text=''
                      icon={<IoCarSport size={24} />}
                      onClick={() => setShowVinReelsModal(true)}
                      disabled={trialExpired}
                    />
                  </Tooltip>
                )}
              </ActionWrapper>
            </FiltersContainer>
            {showFolderOwnerAndSharedBy && (
              <SharedInfoContainer>
                <SharedTitle>
                  {t('Owner')}: {folderOwner}
                </SharedTitle>
                <SharedTitle>
                  {t('Shared By')}: {folderOwner}
                </SharedTitle>
              </SharedInfoContainer>
            )}
            {showLesaModal && (
              <ModalLesaVideos
                handleModalClose={() => setShowLesaModal(false)}
                onCopy={() => {
                  addFolderIDToUrl(DEFAULT_FOLDER.folderId.toString());
                  refreshVideoList();
                }}
              />
            )}
            {showOrganizationVideosModal && (
              <ModalOrganizationVideos
                handleModalClose={() => setShowOrganizationVideosModal(false)}
                onCopy={() => {
                  addFolderIDToUrl(DEFAULT_FOLDER.folderId.toString());
                  refreshVideoList();
                }}
              />
            )}
            {showWTVModal && (
              <ModalWheelsTV
                handleModalClose={() => setWTVModal(false)}
                onCopy={() => {
                  addFolderIDToUrl(DEFAULT_FOLDER.folderId.toString());
                  refreshVideoList();
                }}
              />
            )}
            {showVinReelsModal && (
              <ModalVinReels
                handleModalClose={() => setShowVinReelsModal(false)}
                onCopy={() => {
                  addFolderIDToUrl(DEFAULT_FOLDER.folderId.toString());
                  refreshVideoList();
                }}
              />
            )}
            {showLoading && (
              <LoadingIndicator isLoading={showLoading} height='300px' />
            )}
            {!showLoading && !!videoArray.length && (
              <TableContextProvider
                total={videoCount}
                onChange={onPaginationChange}
                initPage={Math.abs(filter.page)}
                initSize={Math.abs(filter.size)}
              >
                {videoArray.map((video: VideoListAutomotiveItem, index) => (
                  <CheckVideoListItemWrapper
                    data-cy='video-list-item'
                    key={`video-list-item-${index}`}
                  >
                    <CheckboxInputWrapper>
                      {video?.videoRequest?.emailStatus !== 'deleted' &&
                      !hasUserViewAccess ? (
                        <CheckboxInput
                          width='24px'
                          blueCheck={true}
                          disabled={trialExpired}
                          checked={selectedVideosData.includes(video)}
                          dataCy={selectors.libraryPage.videoItemCheckbox}
                          onChange={(e: React.SyntheticEvent) => {
                            let { checked } = e.target as HTMLInputElement;
                            if (checked) {
                              setSelectedVideosData([
                                ...selectedVideosData,
                                video,
                              ]);
                            } else {
                              setSelectedVideosData(
                                selectedVideosData.filter(
                                  (e: any) => e.id != video.id
                                )
                              );
                            }
                          }}
                        />
                      ) : (
                        <CheckboxInputPlaceholder />
                      )}
                    </CheckboxInputWrapper>
                    {(isFolderShared
                      ? hasUserCopyAccess || hasUserViewAccess
                      : video?.folder === DEFAULT_COMPANY_FOLDER ||
                        video?.access === FOLDER_ACCESS.COPY) &&
                      video?.videoRequest?.emailStatus !==
                        VideoEmailStatus.Deleted && (
                        <VideoItemCompany
                          key={'video' + index}
                          recordedBy={video.user}
                          video={video}
                          videoRequest={video?.videoRequest}
                          handleDownload={handleDownload}
                          access={currentFolder.access || ''}
                          disablePinOption={
                            pinnedVideos.length >= MAX_PINNED_VIDEOS_COUNT
                          }
                          currentFolder={currentFolder}
                          isFolderShared={isFolderShared}
                          refreshVideoList={refreshVideoList}
                        />
                      )}
                    {(isFolderShared
                      ? hasUserEditAccess
                      : video?.folder !== DEFAULT_COMPANY_FOLDER &&
                        video?.access !== FOLDER_ACCESS.COPY) && (
                      <VideoItem
                        key={video.id}
                        videoItemType={VideoItemType.Video}
                        recordedBy={video.user}
                        assignedTo={
                          isAutomotive
                            ? video?.videoRequest?.advisor
                            : undefined
                        }
                        video={video}
                        videoRequest={
                          isAutomotive ? video?.videoRequest : undefined
                        }
                        repairOrder={
                          isAutomotive ? video?.repairOrder : undefined
                        }
                        handleReassignSubmit={handleReassignSubmit}
                        handleMerge={handleMerge}
                        handleDownload={handleDownload}
                        handleDuplicate={handleDuplicate}
                        handleMoveCopyButtonClick={handleMoveCopyButtonClick}
                        refreshVideoList={refreshVideoList}
                        videoLimitStatus={videoLimitStatus}
                        currentFolder={currentFolder}
                        isFolderShared={isFolderShared}
                        setSelectedVideos={setSelectedVideo}
                        disablePinOption={
                          pinnedVideos.length >= MAX_PINNED_VIDEOS_COUNT
                        }
                        handleOnMarkAsSentSuccessCallback={
                          handleOnMarkAsSentSuccessCallback
                        }
                      />
                    )}
                  </CheckVideoListItemWrapper>
                ))}
                <PaginationWrapper>
                  <TableFooter>
                    <TablePaginationNew />
                    <TablePaginationSizeNew text={t('Show videos:')} />
                  </TableFooter>
                </PaginationWrapper>
              </TableContextProvider>
            )}
            {!showLoading && !videoArray.length && (
              <>
                {!!showUploadButton() ? (
                  <Flex
                    gap='20px'
                    justifyContent='center'
                    alignItems='center'
                    margin='200px 0px 0px 400px'
                    width='224px'
                  >
                    <ParagraphNormal>
                      {t('No videos yet, upload videos')}
                    </ParagraphNormal>
                    <Button
                      text={t('Upload')}
                      icon={<MdAdd size={22} />}
                      onClick={() => {
                        setIsUploadModalOpen(true);
                      }}
                    />
                  </Flex>
                ) : (
                  <NoList>{t('No videos to show.')}</NoList>
                )}
              </>
            )}
          </MainWrapper>
        </Container>
        {isUploadModalOpen && (
          <ModalUpload
            handleModalClose={() => setIsUploadModalOpen(false)}
            targetFolder={mapFolderToOption(currentFolder, userData.id)}
          />
        )}
        {showModalFilterVideos && (
          <ModalFilterVideos
            handleModalClose={() => setShowModalFilterVideos(false)}
            filter={filter}
            currentFolder={currentFolder?.name}
          />
        )}
        {!!showModalMoveCopyForVideos.videoIds.length && (
          <ModalMoveCopy
            videoIds={showModalMoveCopyForVideos.videoIds}
            currentFolder={currentFolder}
            handleModalClose={() => handleMoveCopyDone()}
            folder={showModalMoveCopyForVideos.folder}
            containsSharedFolderVideos={containsSharedFolderVideo}
            selectedVideos={selectedVideosData}
            // for click inside of menu dropdown
            selectedVideo={selectedVideo}
          />
        )}
        {showEditFolderModal && (
          <CEModalFolders
            currentFolder={{
              name: currentFolder.name,
              folderId: parseInt(currentFolder.folderId.toString(), 10),
              isAIFolder: currentFolder.isAIFolder,
            }}
            handleModalClose={closeEditFolderModal}
          />
        )}
        {showDeleteFolderModal && (
          <ModalDeleteFolder
            onSubmit={handleFolderDelete}
            currentFolder={currentFolder}
            handleModalClose={closeDeleteFolderModal}
          />
        )}
        {showMergeModal && (
          <ModalVideoMergeListVideo
            handleSelectedVideos={(selectedVideos: string[] = []) => {
              history.push('/classic/merge?videos=' + selectedVideos.join(','));
            }}
            handleModalClose={() => setShowMergeModal(false)}
          />
        )}
        {showLeaveFolderModal && (
          <ModalLeaveFolder
            folderName={currentFolder?.name}
            folderId={currentFolder?.folderId}
            handleModalClose={() => setShowLeaveFolderModal(false)}
            refreshFolderList={() => {
              addFolderIDToUrl(DEFAULT_FOLDER.folderId);
            }}
          />
        )}
        {showAdminSelectionModal && (
          <AdminSelectionModal
            handleModalClose={() => setShowAdminSelectionModal(false)}
            currentFolder={currentFolder}
            openOemFolderShareModal={openOemFolderShareModal}
            openFolderShareModal={openFolderShareModal}
          />
        )}
        {showStopFolderSharingModal && (
          <StopFolderSharingModal
            handleModalClose={() => setShowStopFolderSharingModal(false)}
            handleStopFolderSharing={handleStopFolderSharing}
          />
        )}
      </>
    </div>
  );
};
